import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { OverseaInvestment } from '../../../../../types/api'
import { A } from '../../../../atoms/A'
import { IcomoonIcon } from '../../../../atoms/IcomoonIcon'
import {
  Table,
  TableCell,
  TableHead,
  TableHeading,
  TableRow,
} from '../../../../atoms/Table'

type Props = {
  investments: OverseaInvestment[]
}

export const OverseasCompanyFundingRoundInvestments: React.FC<Props> = ({
  investments,
}) => {
  return (
    <div
      css={css`
        padding: 0 8px 0 40px;
      `}
    >
      <Table className="investments-table">
        <TableHead
          css={css`
            height: 32px;
          `}
        >
          <tr
            css={css`
              th {
                padding: 0px 8px;
                font-size: 12px;
                color: ${colors.textLight};
              }
            `}
          >
            <TableHeading width="24px"></TableHeading>
            <TableHeading width="584px">投資家名</TableHeading>
            <TableHeading width="232px" justify="end">
              {/* 投資額 */}
            </TableHeading>
            <TableHeading width="224px"></TableHeading>
          </tr>
        </TableHead>
        <tbody>
          {investments.map((investment) => (
            <TableRow key={investment.investmentId}>
              <TableCell
                centerized
                css={css`
                  padding: 0px;
                `}
              >
                <IcomoonIcon name="box-drawing-character" />
              </TableCell>
              <TableCell
                css={css`
                  padding: 12px 8px;
                `}
              >
                {investment.globalId ? (
                  <A
                    href={`/investors/${investment.globalId}`}
                    target="_blank"
                    rel="noopener"
                    decoration="none"
                  >
                    {investment.name}
                  </A>
                ) : (
                  investment.name
                )}
              </TableCell>
              <TableCell />
              <TableCell />
            </TableRow>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
